import { BodyText, Card, Flex, Heading } from '@utilitywarehouse/hearth-react';
import { TickMediumIcon } from '@utilitywarehouse/hearth-react-icons';

import {
  BannerIllustration,
  BannerIllustrationName,
  BannerIllustrationSize,
  SlideHeading,
  Terms,
} from '@components/PresentationRebrand/ContentSlide/slides/shared';
import { useBreakpoints } from '@utils/useBreakpoints.ts';

import './styles.scss';

type Feature = {
  illustration: BannerIllustrationName;
  size: BannerIllustrationSize;
  mobileSize: BannerIllustrationSize;
  title: string;
  text: string;
};

const FEATURES: Feature[] = [
  {
    illustration: 'confetti',
    size: 'lg',
    mobileSize: 'sm',
    title: 'A little extra cash',
    text: 'Up to £300 per customer.',
  },
  {
    illustration: 'earnings',
    size: 'lg',
    mobileSize: 'sm',
    title: 'Ongoing income',
    text: 'No limit to how much you can earn.',
  },
  {
    illustration: 'calendar',
    size: 'xl',
    mobileSize: 'md',
    title: 'Money for the future',
    text: 'Get paid again and again.',
  },
];

const BENEFITS = ['Simple steps', 'Fits around you', 'Get ongoing support'];

export const MonthlyIncome = () => {
  const { breakpointsDown } = useBreakpoints();
  const isMobile = breakpointsDown.sm;

  return (
    <Flex direction="column" gap="200" className="monthly-income">
      <SlideHeading>
        What would an extra monthly income mean for you?
      </SlideHeading>

      <div className="monthly-income__content">
        <div className="monthly-income__features">
          {FEATURES.map(({ illustration, size, mobileSize, title, text }) => (
            <div key={title} className="monthly-income__feature">
              <div className="monthly-income__feature-media">
                <BannerIllustration
                  name={illustration}
                  size={isMobile ? mobileSize : size}
                />
              </div>
              <div className="monthly-income__feature-text">
                <Heading size="md" asChild>
                  <p>{title}</p>
                </Heading>
                <BodyText size="md">{text}</BodyText>
              </div>
            </div>
          ))}
        </div>

        <Card
          variant="emphasis"
          shadowColor="functional"
          colorScheme="neutralStrong"
          className="monthly-income__card"
        >
          <ul className="monthly-income__benefits">
            {BENEFITS.map((benefit) => (
              <li key={benefit} className="monthly-income__benefit">
                <span className="monthly-income__tick">
                  <TickMediumIcon />
                </span>
                <BodyText size="md">{benefit}</BodyText>
              </li>
            ))}
          </ul>
        </Card>
      </div>

      <Terms />
    </Flex>
  );
};
